// extracted by mini-css-extract-plugin
export default {"container":"status-informer_container__ct0mA","informer":"status-informer_informer__FKI4I","close":"status-informer_close__sGSKR"};